import React, { useCallback, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import cm from 'classnames';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import type { DispatchWithoutAction, ReactElement } from 'react';

import { GroupItem } from '../GroupItem';
import type { Route } from '../../AppRouter/types';

import styles from './Group.module.scss';

interface GroupProps {
  route: Route;
  shadow: boolean;
  toggle: DispatchWithoutAction;
}

export function Group({ route, shadow, toggle }: GroupProps): ReactElement | null {
  const [hoverLinks, setHoverLinks] = useState<Route[]>([]);

  const { title = '', routes, path, icon } = route;

  const visibleRoutes = useMemo(() => routes?.filter((item) => !item.hidden), [routes]);
  const visibleHoverLinks = useMemo(() => hoverLinks?.filter((item) => !item.hidden), [hoverLinks]);

  const onMouseLeave = useCallback(() => {
    setHoverLinks([]);
    toggle();
  }, [toggle]);

  return (
    <>
      <div
        className={cm(styles.container, { [styles.shadow]: shadow })}
        onMouseEnter={toggle}
        onMouseLeave={onMouseLeave}
      >
        <Link to={path ?? ''} className={styles.block}>
          <div>{icon && <Icon name={icon} />}</div>
          <p className={styles.title}>{title}</p>
          <div className={styles.count}>{visibleRoutes?.length || 1}</div>
        </Link>

        {!!visibleRoutes?.length && (
          <div className={cm(styles.inner, { [styles.hover]: visibleHoverLinks.length > 0 })}>
            <ul className={styles.links}>
              {visibleRoutes?.map((item) => (
                <GroupItem key={`${item.title}-${item.path}`} route={item} setHoverLinks={setHoverLinks} />
              ))}
            </ul>

            {visibleHoverLinks.length > 0 && (
              <>
                <div className={styles.divider} />
                <ul className={styles.links}>
                  {visibleHoverLinks.map((item) => (
                    <GroupItem key={`${item.title}-${item.path}`} route={item} setHoverLinks={setHoverLinks} />
                  ))}
                </ul>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
}
